/**
 * TYPES
 */
import {IAgentState} from 'src/aggregates/agents/state.d';


/**
 * CODE
 */

/**
 * Agents initial state.
 */
const initialState: IAgentState = {
    byId: {},
    hasCreateError: false,
    hasLoadError: false,
    hasRemoveError: false,
    hasUpdateError: false,
    isCreating: false,
    isLoading: false,
    isRemoving: false,
    isUpdating: false,
    metrics: {
        end: null,
        hasLoadError: false,
        isLoading: false,
        login: {
            byAgent: {},
            byDate: {},
            statusChanges: [],
        },
        start: null,
    },
};


/**
 * EXPORTS
 */
export default initialState;
